import "../../common/polyfills"
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { IWaMembershipFormProps, WaMemberShipForm } from "./Components/WaMembershipForm";

function MountWaMembershipForm(props: IWaMembershipFormProps, el: Element) {
    ReactDOM.render(<GoogleReCaptchaProvider reCaptchaKey={props.reCaptchaSiteKey}><WaMemberShipForm {...props} /></GoogleReCaptchaProvider>, el)
}

(window as any).MountWaMembershipForm = MountWaMembershipForm;


